package com.karyadina.freesource.data

object FreeSourceData {
    val json = """
    [
      {
        "id": "gov-001",
        "category": { "en": "Government Data", "hi": "सरकारी डेटा" },
        "title": { "en": "Open Government Data (OGD)", "hi": "ओपन गवर्नमेंट डेटा (OGD)" },
        "url": "https://data.gov.in/",
        "description": { "en": "Access thousands of free datasets published by various departments of the Government of India.", "hi": "भारत सरकार के विभिन्न विभागों द्वारा प्रकाशित हजारों मुफ्त डेटासेट तक पहुंचें।" },
        "tags": ["data", "government", "statistics"]
      },
      {
        "id": "news-001",
        "category": { "en": "News & Information", "hi": "समाचार और जानकारी" },
        "title": { "en": "Prasar Bharati (News On AIR)", "hi": "प्रसार भारती (News On AIR)" },
        "url": "https://newsonair.gov.in/",
        "description": { "en": "Official national news provider giving authentic news and updates from across India.", "hi": "आधिकारिक राष्ट्रीय समाचार प्रदाता जो पूरे भारत से प्रामाणिक समाचार देता है।" },
        "tags": ["news", "radio", "government"]
      },
      {
        "id": "law-001",
        "category": { "en": "Free Tools & Utilities", "hi": "मुफ्त उपकरण" },
        "title": { "en": "Indian Kanoon", "hi": "इंडियन कानून" },
        "url": "https://indiankanoon.org/",
        "description": { "en": "A free search engine for Indian Law and court judgments.", "hi": "भारतीय कानून और अदालती फैसलों के लिए एक मुफ्त सर्च इंजन।" },
        "tags": ["law", "utility", "judgments"]
      },
      {
        "id": "edu-001",
        "category": { "en": "E-Learning Platforms", "hi": "ई-लर्निंग प्लेटफॉर्म" },
        "title": { "en": "SWAYAM", "hi": "स्वयं (SWAYAM)" },
        "url": "https://swayam.gov.in/",
        "description": { "en": "Free online courses provided by the Government of India.", "hi": "भारत सरकार द्वारा प्रदान किए गए मुफ्त ऑनलाइन पाठ्यक्रम।" },
        "tags": ["courses", "education", "government"]
      },
      {
        "id": "edu-002",
        "category": { "en": "E-Learning Platforms", "hi": "ई-लर्निंग प्लेटफॉर्म" },
        "title": { "en": "Swayam Prabha", "hi": "स्वयं प्रभा" },
        "url": "https://www.swayamprabha.gov.in/",
        "description": { "en": "A group of DTH channels devoted to telecasting high-quality educational programs.", "hi": "उच्च गुणवत्ता वाले शैक्षिक कार्यक्रमों के प्रसारण के लिए DTH चैनलों का एक समूह।" },
        "tags": ["dth", "tv", "education", "video"]
      },
      {
        "id": "edu-003",
        "category": { "en": "E-Learning Platforms", "hi": "ई-लर्निंग प्लेटफॉर्म" },
        "title": { "en": "Virtual Labs", "hi": "वर्चुअल लैब्स" },
        "url": "https://www.vlab.co.in/",
        "description": { "en": "Remote-access to Labs in various disciplines of Science and Engineering.", "hi": "विज्ञान और इंजीनियरिंग के विभिन्न विषयों में प्रयोगशालाओं तक रिमोट-एक्सेस।" },
        "tags": ["labs", "engineering", "science"]
      },
      {
        "id": "edu-004",
        "category": { "en": "E-Learning Platforms", "hi": "ई-लर्निंग प्लेटफॉर्म" },
        "title": { "en": "FOSSEE", "hi": "FOSSEE" },
        "url": "https://fossee.in/",
        "description": { "en": "Free/Libre and Open Source Software for Education.", "hi": "शिक्षा के लिए मुफ्त और ओपन सोर्स सॉफ्टवेयर।" },
        "tags": ["opensource", "software", "education"]
      },
      {
        "id": "edu-005",
        "category": { "en": "E-Learning Platforms", "hi": "ई-लर्निंग प्लेटफॉर्म" },
        "title": { "en": "Samarth eGov", "hi": "समर्थ ई-गवर्नेंस" },
        "url": "https://samarth.edu.in/",
        "description": { "en": "An open-source, open-standard, robust, secure, scalable and evolutionary process automation engine for Universities.", "hi": "विश्वविद्यालयों के लिए एक ओपन-सोर्स और सुरक्षित प्रोसेस ऑटोमेशन इंजन।" },
        "tags": ["university", "automation", "egov"]
      },
      {
        "id": "ndli-main",
        "category": { "en": "National Digital Library (NDLI)", "hi": "राष्ट्रीय डिजिटल लाइब्रेरी (NDLI)" },
        "title": { "en": "NDLI Official Portal", "hi": "NDLI आधिकारिक पोर्टल" },
        "url": "https://ndl.iitkgp.ac.in/",
        "description": { "en": "Main gateway to millions of learning resources.", "hi": "लाखों शिक्षण संसाधनों का मुख्य प्रवेश द्वार।" },
        "tags": ["library", "education", "NDLI"]
      },
      {
        "id": "ndli-school",
        "category": { "en": "National Digital Library (NDLI)", "hi": "राष्ट्रीय डिजिटल लाइब्रेरी (NDLI)" },
        "title": { "en": "School Education", "hi": "स्कूली शिक्षा" },
        "url": "https://ndl.iitkgp.ac.in/ndl_se",
        "description": { "en": "Textbooks, videos, and study materials for school students.", "hi": "स्कूली छात्रों के लिए पाठ्यपुस्तकें और अध्ययन सामग्री।" },
        "tags": ["school", "education", "NDLI"]
      },
      {
        "id": "ndli-higher",
        "category": { "en": "National Digital Library (NDLI)", "hi": "राष्ट्रीय डिजिटल लाइब्रेरी (NDLI)" },
        "title": { "en": "Higher Education", "hi": "उच्च शिक्षा" },
        "url": "https://ndl.iitkgp.ac.in/ndl_he",
        "description": { "en": "UG/PG resources across multiple disciplines.", "hi": "विभिन्न विषयों में यूजी/पीजी संसाधन।" },
        "tags": ["higher education", "college", "NDLI"]
      },
      {
        "id": "ndli-career",
        "category": { "en": "National Digital Library (NDLI)", "hi": "राष्ट्रीय डिजिटल लाइब्रेरी (NDLI)" },
        "title": { "en": "Career Development", "hi": "कैरियर विकास" },
        "url": "https://ndl.iitkgp.ac.in/ndl_cd",
        "description": { "en": "Competitive exams and skill development resources.", "hi": "प्रतियोगी परीक्षाओं और कौशल विकास के लिए संसाधन।" },
        "tags": ["career", "exams", "NDLI"]
      },
      {
        "id": "nmeict-001",
        "category": { "en": "NMEICT Initiatives", "hi": "NMEICT पहल" },
        "title": { "en": "NPTEL", "hi": "एनपीटीईएल (NPTEL)" },
        "url": "https://nptel.ac.in/",
        "description": { "en": "Largest online repository of engineering and science courses in the world.", "hi": "दुनिया में इंजीनियरिंग और विज्ञान पाठ्यक्रमों का सबसे बड़ा ऑनलाइन भंडार।" },
        "tags": ["engineering", "science", "nmeict", "courses"]
      },
      {
        "id": "nmeict-002",
        "category": { "en": "NMEICT Initiatives", "hi": "NMEICT पहल" },
        "title": { "en": "e-PG Pathshala", "hi": "ई-पीजी पाठशाला" },
        "url": "https://epgp.inflibnet.ac.in/",
        "description": { "en": "High quality, curriculum-based, interactive content in different subjects across all disciplines.", "hi": "सभी विषयों में उच्च गुणवत्ता वाली, पाठ्यक्रम-आधारित, इंटरैक्टिव अध्ययन सामग्री।" },
        "tags": ["pg", "postgraduate", "nmeict", "inflibnet"]
      },
      {
        "id": "nmeict-003",
        "category": { "en": "NMEICT Initiatives", "hi": "NMEICT पहल" },
        "title": { "en": "Shodhganga", "hi": "शोधगंगा" },
        "url": "https://shodhganga.inflibnet.ac.in/",
        "description": { "en": "A reservoir of Indian Electronic Theses and Dissertations for research students.", "hi": "शोध छात्रों के लिए भारतीय इलेक्ट्रॉनिक थीसिस और शोध प्रबंधों का एक भंडार।" },
        "tags": ["thesis", "research", "phd", "nmeict"]
      },
      {
        "id": "nmeict-004",
        "category": { "en": "NMEICT Initiatives", "hi": "NMEICT पहल" },
        "title": { "en": "Spoken Tutorial", "hi": "स्पोकन ट्यूटोरियल" },
        "url": "https://spoken-tutorial.org/",
        "description": { "en": "Learn various IT software through audio-video tutorials in multiple Indian languages.", "hi": "कई भारतीय भाषाओं में ऑडियो-वीडियो ट्यूटोरियल के माध्यम से विभिन्न आईटी सॉफ्टवेयर सीखें।" },
        "tags": ["it", "software", "programming", "nmeict"]
      },
      {
        "id": "nmeict-005",
        "category": { "en": "NMEICT Initiatives", "hi": "NMEICT पहल" },
        "title": { "en": "e-Yantra", "hi": "ई-यंत्र" },
        "url": "https://www.e-yantra.org/",
        "description": { "en": "A project to incorporate Robotics into engineering education.", "hi": "इंजीनियरिंग शिक्षा में रोबोटिक्स को शामिल करने की एक परियोजना।" },
        "tags": ["robotics", "engineering", "nmeict"]
      },
      {
        "id": "research-001",
        "category": { "en": "Govt. Research & Innovation", "hi": "सरकारी अनुसंधान और नवाचार" },
        "title": { "en": "IIRS ISRO E-Class", "hi": "IIRS इसरो ई-क्लास" },
        "url": "https://elearning.iirs.gov.in/",
        "description": { "en": "ISRO's distance learning program offering free courses on space science, remote sensing, and GIS.", "hi": "अंतरिक्ष विज्ञान, रिमोट सेंसिंग और जीआईएस पर मुफ्त पाठ्यक्रम पेश करने वाला इसरो का दूरस्थ शिक्षा कार्यक्रम।" },
        "tags": ["isro", "space", "science", "gis", "remote-sensing"]
      },
      {
        "id": "research-002",
        "category": { "en": "Govt. Research & Innovation", "hi": "सरकारी अनुसंधान और नवाचार" },
        "title": { "en": "Bhuvan (ISRO)", "hi": "भुवन (इसरो)" },
        "url": "https://bhuvan.nrsc.gov.in/",
        "description": { "en": "ISRO's geo-portal providing free high-resolution Indian earth observation data and map services.", "hi": "इसरो का जियो-पोर्टल जो उच्च-रिज़ॉल्यूशन वाले भारतीय पृथ्वी अवलोकन डेटा और मानचित्र सेवाएँ निःशुल्क प्रदान करता है।" },
        "tags": ["isro", "maps", "geography", "earth-observation"]
      },
      {
        "id": "research-003",
        "category": { "en": "Govt. Research & Innovation", "hi": "सरकारी अनुसंधान और नवाचार" },
        "title": { "en": "Jigyasa (CSIR)", "hi": "जिज्ञासा (CSIR)" },
        "url": "https://jigyasa-csir.in/",
        "description": { "en": "Student-Scientist connect program by CSIR for promoting scientific temper among school students.", "hi": "स्कूली छात्रों के बीच वैज्ञानिक दृष्टिकोण को बढ़ावा देने के लिए CSIR द्वारा छात्र-वैज्ञानिक संपर्क कार्यक्रम।" },
        "tags": ["csir", "science", "students", "innovation"]
      },
      {
        "id": "research-004",
        "category": { "en": "Govt. Research & Innovation", "hi": "सरकारी अनुसंधान और नवाचार" },
        "title": { "en": "DESIDOC (DRDO)", "hi": "डेसीडॉक (DRDO)" },
        "url": "https://publications.drdo.gov.in/",
        "description": { "en": "Free access to DRDO science journals, defense publications, and research monographs.", "hi": "DRDO विज्ञान पत्रिकाओं, रक्षा प्रकाशनों और अनुसंधान मोनोग्राफ तक मुफ्त पहुंच।" },
        "tags": ["drdo", "defense", "research", "publications"]
      },
      {
        "id": "research-005",
        "category": { "en": "Govt. Research & Innovation", "hi": "सरकारी अनुसंधान और नवाचार" },
        "title": { "en": "CSIR-NIScPR Online Periodicals", "hi": "CSIR-NIScPR ऑनलाइन पत्रिकाएं" },
        "url": "https://nopr.niscpr.res.in/",
        "description": { "en": "Free access to full-text articles from research journals published by CSIR.", "hi": "CSIR द्वारा प्रकाशित शोध पत्रिकाओं से पूर्ण-पाठ लेखों तक मुफ्त पहुंच।" },
        "tags": ["csir", "journals", "research", "science"]
      }
    ]
    """.trimIndent()
}
